import { Endpoints } from "../../../constants/endpoints";
import client from "../../client";
import { TRegisterUser, TAuthorizeUserBody } from "./types";

export const postAuthorizeUser = async (payload: TAuthorizeUserBody) => {
  const { data } = await client.post<TAuthorizeUserBody, TRegisterUser>(
    Endpoints.postAuthorizeUser,
    {
      ...payload,
    },
    {
      headers: {
        "Content-Type": "application/json",
      },
    }
  );
  return data;
};
